/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_c5788fa2{border:0;outline:0;width:100%}.editingInput_c5788fa2::-ms-clear{display:none}.editingContainer_c5788fa2{margin:4px}"}]);
export const editingInput = "editingInput_c5788fa2";
export const editingContainer = "editingContainer_c5788fa2";